// FEATURE-36 — per-theme launcher button icon.
//
// Each theme ships its own inline SVG mark for the floating button. The
// `default` theme uses a chat-bubble (signals conversational UI); the
// `worldtrans` theme uses a paper-plane (signals travel + outbound
// communication, matching the brand's travel-agency identity).
//
// All SVGs use `stroke="currentColor"` so they inherit the foreground
// token from LAUNCHER_TOKENS — no per-theme color baked in.

import type { ThemeName } from '@ba/protocol';

const CHAT_BUBBLE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>`;

const PAPER_PLANE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></svg>`;

export const LAUNCHER_ICONS: Record<ThemeName, string> = {
  default: CHAT_BUBBLE_SVG,
  worldtrans: PAPER_PLANE_SVG,
};
